module.exports = __webpack_public_path__ + "img/firewallSetting-c.055640e.svg";